export const categoryFragment = `
has_nicotine
is_transparent_header
`
